import { createContext, useContext } from 'react';
export const FormFieldsContext = /*#__PURE__*/createContext(undefined);
export function useField(fieldId) {
  const context = useContext(FormFieldsContext);
  if (context === undefined) {
    throw new Error('useFieldView must be used within a FormViewProvider');
  }
  const fieldView = context.find(field => field.id === fieldId);
  return fieldView;
}
//# sourceMappingURL=form-fields-context.js.map